module.exports = __webpack_public_path__ + "img/icon_num_wx.2a484c07.png";